const worker = new Worker(
    new URL("./resumableUploadWorker.ts", import.meta.url),
    {
        type: "module",
    }
);

export default worker;
